import Moment from "moment";
const normalised = {
    location: null,
    pitch: null,
    dhbMatch: null,
    matchChanged: true,
    scheduleDate: "",
    scheduleTime: "",
};
/**
 * Normalise data structure before submit.
 */
export const normaliseForm = (form) => {
    const fullForm = _.cloneDeep(form);

    normalised.scheduleDate = Moment(fullForm.scheduleDate).format(
        "YYYY-MM-DD"
    );
    normalised.scheduleTime = Moment(
        fullForm.scheduleTime,
        "HH:mm:ss",
        true
    ).isValid()
        ? Moment(fullForm.scheduleTime).format("HH:mm:ss")
        : null;

    normalised.dhbMatch = fullForm.id;
    normalised.location = fullForm.location?.id;
    normalised.pitch = fullForm.pitchID;
    normalised.status = fullForm.status;

    return normalised;
};
